import axios from 'axios'
import { capiCreator } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import orderBy from 'lodash.orderby'

const FETCH_CATEGORIES = 'categories/FETCH_CATEGORIES'
const FETCH_CATEGORIES_SUCCESS = 'categories/FETCH_CATEGORIES_SUCCESS'
const FETCH_CATEGORIES_FAIL = 'categories/FETCH_CATEGORIES_FAIL'

const FETCH_CATEGORY = 'categories/FETCH_CATEGORY'
const FETCH_CATEGORY_SUCCESS = 'categories/FETCH_CATEGORY_SUCCESS'
const FETCH_CATEGORY_FAIL = 'categories/FETCH_CATEGORY_FAIL'

const PUT_CATEGORY = 'categories/PUT_CATEGORY'
const PUT_CATEGORY_SUCCESS = 'categories/PUT_CATEGORY_SUCCESS'
const PUT_CATEGORY_FAIL = 'categories/PUT_CATEGORY_FAIL'

const SET_SNACKBAR_MESSAGE = 'categories/SET_SNACKBAR_MESSAGE'
const CLEAR_SNACKBAR_MESSAGE = 'categories/CLEAR_SNACKBAR_MESSAGE'

export const ACTIONS = {
  FETCH_CATEGORIES,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAIL,
  FETCH_CATEGORY,
  FETCH_CATEGORY_SUCCESS,
  FETCH_CATEGORY_FAIL,
  PUT_CATEGORY,
  PUT_CATEGORY_SUCCESS,
  PUT_CATEGORY_FAIL,
  SET_SNACKBAR_MESSAGE,
  CLEAR_SNACKBAR_MESSAGE
}

export const initialState = {
  categories: [],
  fetchingCategories: false,
  fetchCategoriesError: null,
  editingCategory: null,
  fetchingCategory: false,
  fetchCategoryError: null,
  savingCategory: false,
  saveCategoryError: null,
  snackbarMessage: null
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_CATEGORIES:
      return {
        ...state,
        fetchingCategories: true,
        fetchCategoriesError: null
      }
    case FETCH_CATEGORIES_SUCCESS:
      return {
        ...state,
        fetchingCategories: false,
        categories: orderBy(payload, [(cat) => cat.name.toLowerCase()])
      }
    case FETCH_CATEGORIES_FAIL:
      return {
        ...state,
        fetchingCategories: false,
        fetchCategoriesError: payload
      }
    case FETCH_CATEGORY:
      return {
        ...state,
        fetchingCategory: true,
        fetchCategoryError: null
      }
    case FETCH_CATEGORY_SUCCESS:
      return {
        ...state,
        fetchingCategory: false,
        editingCategory: payload
      }
    case FETCH_CATEGORY_FAIL:
      return {
        ...state,
        fetchingCategory: false,
        fetchCategoryError: payload
      }
    case PUT_CATEGORY:
      return {
        ...state,
        savingCategory: true,
        saveCategoryError: null
      }
    case PUT_CATEGORY_SUCCESS:
      return {
        ...state,
        savingCategory: false
      }
    case PUT_CATEGORY_FAIL:
      return {
        ...state,
        savingCategory: false,
        saveCategoryError: payload
      }
    case SET_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: payload
      }
    case CLEAR_SNACKBAR_MESSAGE:
      return {
        ...state,
        snackbarMessage: null
      }
    default:
      return state
  }
}

export default reducer

export const setSnackBarMessage = (message) => ({
  type: SET_SNACKBAR_MESSAGE,
  payload: message
})

export const clearSnackbarMessage = () => ({
  type: CLEAR_SNACKBAR_MESSAGE
})

export const saveOrUpdateCategory = (cat) =>
  capiCreator(PUT_CATEGORY, PUT_CATEGORY_SUCCESS, PUT_CATEGORY_FAIL, () =>
    axios.patch(`/categories/${cat.id}`, cat, { headers: { 'x-api': 'positions_v1' } })
  )

export const fetchCategory = (id) =>
  capiCreator(FETCH_CATEGORY, FETCH_CATEGORY_SUCCESS, FETCH_CATEGORY_FAIL, () =>
    axios.get(`/categories/${id}`, { headers: { 'x-api': 'positions_v1' } })
  )

export const fetchCategories = () =>
  capiCreator(FETCH_CATEGORIES, FETCH_CATEGORIES_SUCCESS, FETCH_CATEGORIES_FAIL, () =>
    axios.get('/categories', { headers: { 'x-api': 'positions_v1' } })
  )



// WEBPACK FOOTER //
// ./src/modules/Positions/reducers/categories.js